import { ClassroomDegree } from '@/core/domain/resources/enums/ClassroomDegree.ts'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'
import {
  type ExportFilterInputEntity,
  ExportFilterInputSchema
} from '@/core/infrastructure/schemas/exports/ExportSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export default class ExportFilterInput {
  readonly year: number
  readonly schools: number[]
  readonly degrees: ClassroomDegree.Values[]
  readonly classrooms: number[]
  readonly diagnosticType?: QuizType.Values | null

  constructor(filters: ExportFilterInputEntity) {
    this.year = filters.year
    this.schools = filters.schools ?? []
    this.degrees = filters.degrees ?? []
    this.classrooms = filters.classrooms ?? []
    this.diagnosticType = filters.diagnosticType ?? null
  }

  copy(patch: Partial<ExportFilterInput>): ExportFilterInput {
    return new ExportFilterInput({
      year: this.year,
      schools: this.schools,
      degrees: this.degrees,
      classrooms: this.classrooms,
      diagnosticType: this.diagnosticType,
      ...patch
    });
  }

  isValid(): boolean {
    if (this.diagnosticType) {
      return this.year > 0 && (this.diagnosticType === QuizType.Values.DIAG_START || this.diagnosticType === QuizType.Values.DIAG_END);
    }
    return this.year > 0;
  }

  public static fromYear(year: number): ExportFilterInput {
    return ExportFilterInput.create({
      year: year,
      schools: [],
      degrees: [],
      classrooms: [],
      diagnosticType: null
    })
  }

  public static create(data: unknown): ExportFilterInput {
    return EntityValidator.validateAndCreate(
      ExportFilterInputSchema,
      data,
      ExportFilterInput,
      'ExportFilterInput'
    )
  }
}